<template>
  <div class="liu">
    <!-- 标题 -->
    <mt-header fixed :title="title" class="title2 border-b">
      <mt-button slot="left" icon="back" @click="$router.go(-1)">返回</mt-button>
    </mt-header>
    <!-- 内容 -->
    <div class="content" v-if="myDataDetail.name">
      <!-- 用户信息 -->
      <div class="agent-info detail">
        <img :src="myDataDetail.logoUrl || require('../assets/image_default_agent@3x.png')" width="44" height="44" />
        <span class="agent-name">{{ myDataDetail.name }}</span>
        <span class="agent-status" :class="getuserStatusClass(myDataDetail.status)">{{ myDataDetail.statusMsg }}</span>
        <span class="agent-tel" @click="onUserMobileClick">{{ getUserDetailMoblie(myDataDetail.mobile) }}</span>
      </div>
      <!-- 基本信息 -->
      <div class="agent-push-box">
        <div class="agent-push center">
          <span class="fee-info-box">注册时间</span>
          <span class="fee-info-box">{{ myDataDetail.insertDate }}</span>
        </div>
        <div class="agent-push center">
          <span class="fee-info-box">商户地址</span>
          <span class="fee-info-box">{{ myDataDetail.address }}</span>
        </div>
        <div class="agent-push center" v-if="isShowByNoPos">
          <span class="fee-info-box">POS终端编号</span>
          <span class="fee-info-box">{{ myDataDetail.sn }}</span>
        </div>
        <div class="agent-push center" v-if="isShowByNoPos">
          <span class="fee-info-box">POS开通时间</span>
          <span class="fee-info-box">{{ myDataDetail.openDate || "--" }}</span>
        </div>
      </div>
      <!-- 费率 -->
      <div class="agent-fee-box" v-if="myDataDetail.rateResponses && myDataDetail.rateResponses.length">
        <div class="agent-detail-title">
          <div>
            <span slot="icon" class="blue_line"></span>
            <span>费率</span>
          </div>
        </div>
        <div class="agent-fee" :class="setRateClass(item.rateName, item.agentRate)" v-for="(item, index) in myDataDetail.rateResponses" :key="index">
          <div class="fee-info-box" :class="multRateClass(item.agentRate)">
            <span v-html="formatRateName(item.rateName)" />
          </div>
          <div class="fee-info-box" :class="multRateClass(item.agentRate)">
            <span v-html="formatRateValue(item.agentRate)" />
          </div>
        </div>
      </div>
      <!-- 收银员 -->
      <div class="agent-fee-box" v-if="myDataDetail.cashierListResponses && myDataDetail.cashierListResponses.length">
        <el-collapse>
          <el-collapse-item>
            <template slot="title">
              <div class="agent-detail-title bb0">
                <div>
                  <span slot="icon" class="blue_line"></span>
                  <span>收银员</span>
                </div>
              </div>
            </template>
            <div class="agent-fee center" v-for="(item, index) in myDataDetail.cashierListResponses" :key="index">
              <div class="fee-merchant-box">
                <span>{{ item.merchantName }}</span>
                <span>（{{ item.jyuuid || item.status | cashierStatusChs }}）</span>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
      <!-- 本月业绩 -->
      <div class="agent-detail-box" v-if="myDataDetail.reward && myDataDetail.reward.length">
        <el-collapse>
          <el-collapse-item>
            <template slot="title">
              <div class="agent-detail-title">
                <div>
                  <span slot="icon" class="blue_line"></span>
                  <span>本月业绩</span>
                </div>
              </div>
            </template>
            <div class="agent-detail" v-for="(itemA, indexA) in myDataDetail.reward" :key="indexA">
              <div class="item-cell">
                <div class="cell-top-b">{{ itemA.date }}</div>
                <div class="cell-bottom">{{ itemA.name }}</div>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { Indicator } from 'mint-ui';
import { CusToast } from '@/utils/CustomToast';
import { GetMyUserOne } from '@/api/agent.js';
import { SucceedHandle, NotSucceedHandle } from '@/api/handle';
export default {
  name: 'CustomerDetail',
  data() {
    return {
      imgEyePath: 'hide_money',
      title: '商户详情',
      myDataDetail: {},
      realRewardData: [],
      starRewardData: [],
      userMobileShowStar: true,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getMyData(this.$route.query.userid);
    });
  },
  computed: {
    isShowByNoPos() {
      return !(this.myDataDetail.sn === '没有设备');
    },
  },
  methods: {
    // 获取代理商详情
    getMyData(userid) {
      Indicator.open();
      GetMyUserOne({ userId: userid })
        .then(res => {
          Indicator.close();
          const msg = SucceedHandle(res.code, res.msg, () => {
            this.myDataDetail = res.data;
            this.myDataDetail.status = this.$route.query.status;
            this.myDataDetail.statusMsg = this.$route.query.statusMsg;
          });
          msg && CusToast(msg);
        })
        .catch(err => {
          Indicator.close();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
          this.$router.go(-1);
        });
    },
    // 点击眼睛事件
    handleEyeClick() {
      if (this.imgEyePath === 'hide_money') {
        this.myDataDetail.reward = this.realRewardData;
        this.imgEyePath = 'show_money';
      } else if (this.imgEyePath === 'show_money') {
        this.myDataDetail.reward = this.starRewardData;
        this.imgEyePath = 'hide_money';
      }
    },
    // 星星/数据相互替换
    copyReward() {
      this.realRewardData = JSON.parse(JSON.stringify(this.myDataDetail.reward));
      this.starRewardData = JSON.parse(JSON.stringify(this.realRewardData));
      this.starRewardData.forEach(item => (item.date = '****'));
      this.myDataDetail.reward = this.starRewardData;
    },
    // 设置费率标题样式
    setRateClass(name, data) {
      let rateClass = 'center';
      if (data.indexOf('\n') > -1) {
        rateClass = 'start';
      } else {
        const len = name.length;
        switch (document.body.clientWidth) {
          case 320:
            rateClass = len > 6 ? 'start' : 'center';
            break;
          case 360:
            rateClass = len > 7 ? 'start' : 'center';
            break;
          case 375:
            rateClass = len > 8 ? 'start' : 'center';
            break;
          case 411:
          case 414:
            rateClass = len > 9 ? 'start' : 'center';
            break;
          case 480:
            rateClass = len > 10 ? 'start' : 'center';
            break;
          default:
            rateClass = 'center';
            break;
        }
      }
      return rateClass;
    },
    // 设置多行费率样式
    multRateClass(value) {
      return { mult: String(value).indexOf('\n') > -1 };
    },
    // 格式化费率标题
    formatRateName(name) {
      return name.replace(/费率/g, '');
    },
    // 格式化费率内容
    formatRateValue(value) {
      let tmp = value.replace(/\n/g, ',<br>');
      tmp = tmp.replace(/＋/g, '+').replace(/％/g, '%');
      const tmpArr = tmp.split(',');
      const tmpNewArr = [];
      tmpArr.forEach(str => {
        if (str.indexOf('+') > -1 && str.indexOf('%') === -1 && str.indexOf('0+') === -1) {
          tmpNewArr.push(str.replace(/[+]/g, '%+'));
        } else {
          tmpNewArr.push(str);
        }
      });
      return tmpNewArr.join('，');
    },
    // 返回用户状态的样式名称
    getuserStatusClass(val) {
      return `status${val}`;
    },
    // 用户手机号点击事件
    onUserMobileClick() {
      this.userMobileShowStar = !this.userMobileShowStar;
    },
    // 返回手机号的显示格式
    getUserDetailMoblie(val) {
      return this.userMobileShowStar ? `${String(val).substr(0, 3)}****${String(val).substr(-4)}` : val;
    },
  },
  filters: {
    cashierStatusChs(val) {
      if (val === 0) return '未开通';
      if (val === 1) return '未绑定';
      if (val === 2) return '未写入';
      if (val === 3) return '已写入';
      if (val) return val;
    },
    mobile(val) {
      if (!val) return val;
      return `${String(val).substr(0, 3)}****${String(val).substr(-4)}`;
    },
  },
};
</script>
